import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { IconSeekers } from 'ui-seeker/core'

import { useBannerMessages } from './@hooks'

export default function MaintenanceBanner() {
    const { t, i18n } = useTranslation('common')
    const { messages } = useBannerMessages()

    if (!messages.length) return null

    // Backend sends one `text_<lang>` per supported language; fall back to EN, then ES.
    const lang = (i18n.language || 'en').slice(0, 2)
    const textOf = m => m[`text_${lang}`] || m.text_en || m.text_es

    return <div className="maintenance-banner" role="alert">
        <div className="maintenance-banner__icon">
            <IconSeekers icon="triangle-exclamation" iconType="fontAwesome" iconWeight="fas" />
        </div>
        <div className="maintenance-banner__body">
            <span className="maintenance-banner__title">{t('common:maintenanceBanner.title')}</span>
            {messages.map(m => <p key={m.id_banner_message} className="maintenance-banner__line">
                {textOf(m)}
            </p>)}
        </div>
    </div>
}
